import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material'
import Sheet from '../../components/Sheet'
import { REJECTION_REASONS } from './reviewModel'

const NOTE_MAX_LENGTH = 500

export default function RejectDialog({ open, shotLabel, onConfirm, onCancel }) {
    const { t } = useTranslation()
    const [reason, setReason] = useState('')
    const [note, setNote] = useState('')

    // Each reopening starts from a blank pick, rather than carrying over the
    // previous shot's answer.
    useEffect(() => {
        if (open) {
            setReason('')
            setNote('')
        }
    }, [open])

    const trimmed = note.trim()
    const noteRequired = reason === 'other'
    const canConfirm = Boolean(reason) && (!noteRequired || trimmed.length > 0)

    function handleConfirm() {
        onConfirm({ reason, note: trimmed.length > 0 ? trimmed : null })
    }

    return (
        <Sheet
            open={open}
            onClose={onCancel}
            title={t('photoReview.reject.title', { label: shotLabel })}
            actions={(
                <>
                    <Button onClick={onCancel}>{t('photoReview.reject.cancel')}</Button>
                    <Button variant='contained' color='error' disabled={!canConfirm} onClick={handleConfirm}>
                        {t('photoReview.reject.confirm')}
                    </Button>
                </>
            )}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <FormControl>
                    <FormLabel id='reject-reason-label'>{t('photoReview.reject.reasonLabel')}</FormLabel>
                    <RadioGroup aria-labelledby='reject-reason-label' value={reason} onChange={e => setReason(e.target.value)}>
                        {REJECTION_REASONS.map(code => (
                            <FormControlLabel key={code} value={code} control={<Radio />} label={t(`photoReview.reject.reasons.${code}`)} />
                        ))}
                    </RadioGroup>
                </FormControl>
                <TextField
                    label={t('photoReview.reject.noteLabel')}
                    value={note}
                    onChange={e => setNote(e.target.value.slice(0, NOTE_MAX_LENGTH))}
                    multiline
                    minRows={2}
                    inputProps={{ maxLength: NOTE_MAX_LENGTH }}
                />
            </Box>
        </Sheet>
    )
}
